import { render, staticRenderFns } from "./option-item.vue?vue&type=template&id=36b56e74&"
import script from "./option-item.vue?vue&type=script&lang=ts&"
export * from "./option-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b56e74')) {
      api.createRecord('36b56e74', component.options)
    } else {
      api.reload('36b56e74', component.options)
    }
    module.hot.accept("./option-item.vue?vue&type=template&id=36b56e74&", function () {
      api.rerender('36b56e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/dropdown/option-item.vue"
export default component.exports